import { useCookie } from '#app'
import cookie, { type CookieSerializeOptions } from 'cookie'

const useCookieMonster = defineStore('cookieMonster', () => {
  const app = useNuxtApp()

  const getAll = () => {
    if (import.meta.server) {
      const cookieStr = app.ssrContext?.event.node.req.headers.cookie
      const parsedCookies = cookie.parse(cookieStr ?? '')
      return parsedCookies
    } else {
      const cookies = document.cookie
      return cookie.parse(cookies)
    }
  }

  const get = (name: string) => {
    if (!name || typeof name !== 'string') return null
    const cookies = getAll()
    const cookie = Object.keys(cookies).find(
      (key) => name.toLowerCase() === key.toLowerCase(),
    )
    return cookie ?? null
  }
  const set = (
    name: string,
    value: string,
    opts: CookieSerializeOptions = { path: '/' },
  ) => {
    useCookie(name, opts).value = value
  }

  return {
    getAll,
    get,
    set,
  }
})

export default defineNuxtPlugin({
  name: 'cookieMonster',
  dependsOn: ['pinia'],
  setup(nuxtApp) {
    const cookies = useCookieMonster()
    return {
      provide: {
        cookies: cookies,
      },
    }
  },
})
